import React from 'react';
import './subscription.scss';
import {
  getPGCustomerId,
  validateUPI,
} from 'hb-redux-store/feature/checkout/checkout.action';
import { connect } from 'react-redux';
import SecondaryNav from '../SecondaryNav/SecondaryNav';
import Cards from '../Payments/Cards';
import Upis from '../Payments/Upis';
import Loader from '../Skeletons/Loader/Loader';
import Wallets from '../Payments/Wallets';
import NetBanks from '../Payments/NetBanks';
import COD from '../../../feature/checkout/COD';
import { getSubscriptionRoute } from './subscription.routes';
import { setAppNotification } from 'hb-redux-store/initial.action';
import { setCartQtyCount } from 'hb-redux-store/feature/cart/cart.action';
import history from 'hb-redux-store/history';
import { SUBSCRIPTION_FAILURE_REDIRECT } from 'hb-redux-store/util/constantServices';
import {
  setPaymentFailModal,
  showOrderFailedModal,
} from 'hb-redux-store/feature/modal/modal.action';
import RazorpayService from 'hb-redux-store/util/RazorpayService';
import Button from '../../common/Button/Button';
import Modal from '../Modal/Modal';
import { queryStringToJSON } from 'hb-redux-store/util/miscellaneousServices';
import Messages from '../Messages/Messages';
import {
  postPlaceOrder,
  getPaymentDetails,
} from 'hb-redux-store/feature/subscription/subscription.action';

class SubscriptionPayment extends React.Component {
  state = {
    selectedMode: null,
    razorPayInstance: null,
    paymentInProgress: false,
    showPopupBlockedModal: false,
    razorpayDetails: null,
  };
  paymentInProgress = false;
  PAYMENT_MODES = [
    { key: 'savedCards', title: 'Credit/Debit Cards', component: Cards },
    { key: 'savedUPIs', title: 'UPI', component: Upis },
    { key: 'wallets', title: 'Wallets', component: Wallets },
    { key: 'netBankings', title: 'Net banking', component: NetBanks },
    { key: 'pod', title: 'Pay On Delivery', component: COD },
  ];
  orderWithHBW = () => {
    this.onPlaceOrder({ mode: 'hbw' });
  };
  componentDidMount() {
    this.props.getPaymentDetails();
    const qs = this.props.location.search;
    const { result, reason } = queryStringToJSON(qs);
    if (result === 'failed' && reason) {
      this.props.setPaymentFailModal({ reason, visible: true });
    }
    RazorpayService.initRazorpay();
  }
  showPgInfoPopup = razorpayDetails => {
    this.setState({ razorpayDetails, showPopupBlockedModal: true });
  };
  openRazorpay = () => {
    const { razorPayErrorCb } = this.state.razorpayDetails;
    RazorpayService.makePayment({
      ...this.state.razorpayDetails,
      razorPayErrorCb: () => {
        this.setState(
          {
            razorpayDetails: null,
            showPopupBlockedModal: false,
          },
          () => {
            razorPayErrorCb();
          }
        );
      },
    });
  };

  onPlaceOrder = details => {
    if (this.paymentInProgress || this.state.paymentInProgress) return;
    RazorpayService.initRazorpay();
    this.paymentInProgress = true;
    this.setState({ paymentInProgress: true }, () => {
      const payload = {
        ...details,
        amount: this.props.paymentSummary.payableAmount,
        pgCid: this.props.pgCid,
        pgId: this.props.paymentMethods.pgId,
        successCb: ({ subscriptionNo }) => {
          this.props.setCartQtyCount(0);
          // console.warn(history);
          this.paymentInProgress = false;
          history.push(
            getSubscriptionRoute('subscriptionConfirmation').replace(
              ':subscriptionNo',
              subscriptionNo
            )
          );
        },
        failCb: error => {
          this.setState({ paymentInProgress: false }, () => {
            this.paymentInProgress = false;
            if (error?.step) {
              const redirect =
                error.error?.data?.redirect || error.redirect || null;
              if (
                redirect?.toLowerCase() ===
                SUBSCRIPTION_FAILURE_REDIRECT.SUBSCRIPTION_SUMMARY.toLowerCase()
              ) {
                this.props.setAppNotification(
                  'Your subscription has changed. You will be shortly redirected to summary'
                );
                return setTimeout(
                  () => history.push('/ramadan-subscription'),
                  2000
                );
              } else if (
                redirect?.toLowerCase() ===
                SUBSCRIPTION_FAILURE_REDIRECT.ORDER_FAILURE
              ) {
                this.props.showOrderFailedModal(true);
                history.push('/ramadan-subscription');
              } else if (
                redirect?.toLowerCase() ===
                SUBSCRIPTION_FAILURE_REDIRECT.PG_NOT_LOADED
              ) {
                this.props.setAppNotification(
                  'Error loading Payment Gateway. Refresh and try again.'
                );
              } else if (
                redirect === SUBSCRIPTION_FAILURE_REDIRECT.SHOW_PG_INFO_POPUP
              ) {
                this.showPgInfoPopup(error.pgDetails);
              }
            } else {
              this.props.setAppNotification(error);
            }
          });
        },
      };
      this.props.postPlaceOrder(payload);
    });
  };

  onPaymentModeChange = newMode => {
    this.setState({ selectedMode: newMode });
  };
  render() {
    const { paymentSummary, paymentMethods } = this.props;
    return (
      <div className="payments">
        <SecondaryNav
          showSearch={false}
          showCart={false}
          title="Select Payment Methods"
          capitalize
        />
        {(!paymentSummary || !paymentMethods) && <Loader />}
        {paymentSummary && paymentMethods && (
          <React.Fragment>
            <div className="payments--summary">
              <div className="payments--summary--total-items">
                {`${paymentSummary.totalItems} ${
                  paymentSummary.totalItems > 1 ? 'items' : 'item'
                }`}
              </div>
              <div className="payments--summary--payable justify-content--space-between">
                <div className="">Payable Amount</div>
                <div className="">&#8377;{paymentSummary.payableAmount}</div>
              </div>
            </div>
            {!paymentMethods?.isHBW && (
              <div className="payments--payment-modes">
                {this.PAYMENT_MODES.map(mode => {
                  // if (!paymentMethods[mode.key]) return null;
                  const podProps = {};
                  if (mode.key === 'pod') {
                    podProps.isCodEnable = paymentMethods.isCOD;
                    podProps.codMessage = paymentMethods.isCODMessage;
                    podProps.isPodEnable = paymentMethods.isPOD;
                    podProps.podMessage = paymentMethods.isPODMessage;
                  }
                  return (
                    <mode.component
                      title={mode.title}
                      details={paymentMethods[mode.key]}
                      selectedMode={this.state.selectedMode}
                      onPaymentModeChange={this.onPaymentModeChange}
                      onPlaceOrder={this.onPlaceOrder}
                      validateUPI={this.props.validateUPI}
                      key={mode.key}
                      code={mode.key}
                      pgId={paymentMethods.pgId}
                      {...podProps}
                    />
                  );
                })}
              </div>
            )}
            {paymentMethods?.isHBW && (
              <div>
                <Messages
                  message={
                    paymentMethods?.isHBWMessage ||
                    'Yay! Your order will be paid using your wallet balance. No additional payment is required.'
                  }
                  type="success"
                />
                <div className="bottom-sticky-cta">
                  <Button
                    type="submit"
                    className="button button-primary full-width large"
                    onClick={this.orderWithHBW}
                  >
                    Place Order
                  </Button>
                </div>
              </div>
            )}
          </React.Fragment>
        )}
        <Modal
          visible={this.state.showPopupBlockedModal}
          onCancel={() => this.setState({ showPopupBlockedModal: false })}
          closable={false}
          maskClosable={false}
          wrapClassName="pg-modal-failed"
        >
          <div className="pg-modal-failed--content">
            Proceed to payment
            <br />
          </div>
          <div className="pg-modal-failed--cta">
            <Button
              className="button button-primary full-width"
              onClick={this.openRazorpay}
            >
              Pay Now
            </Button>
          </div>
        </Modal>
        {this.state.paymentInProgress && (
          <div className="payments--oip">
            <Loader />
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = ({ subscriptionReducer, modalReducer }) => ({
  paymentSummary: subscriptionReducer.paymentSummary,
  paymentMethods: subscriptionReducer.paymentMethods,
  pgCid: subscriptionReducer.pgCid,
  orderFailedModal: modalReducer.orderFailedModal,
});

const mapDispatchToProps = {
  getPaymentDetails,
  getPGCustomerId,
  postPlaceOrder,
  setAppNotification,
  validateUPI,
  setCartQtyCount,
  showOrderFailedModal,
  setPaymentFailModal,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SubscriptionPayment);
